import {GetDoctorVisitsListParams} from 'domain/usecases/private/my-hospitalization/get-doctor-visits-list';
import {makeGetDoctorVisitsList} from 'main/factories/usecases/private/my-hospitalization/get-doctor-visits-list-factory';

export const getDoctorVisitsList = async (params: GetDoctorVisitsListParams) => {
	try {
		const response = await makeGetDoctorVisitsList().get(params);

		if (typeof response === 'string') {
			return {
				pages: 0,
				items: [],
			};
		}

		const pages = Math.ceil(response.totalElements / params.size);

		return {
			pages,
			items: response.content,
		};
	} catch (error) {
		throw new Error();
	}
};
